import sunCage from "url:./an9.jpg"
import sunCageDetail from "url:./an2.jpg"
import childCage from "url:./an3.jpg"

import cage from "url:./DSCF1778.jpg";

import iAwait from "url:./1.jpg";
import bones from "url:./5.jpg";
import solemn from "url:./8.jpg";
import redchamber from "url:./9.jpg";
import home from "url:./10.jpg";
import misery from "url:./12.jpg";
import keymaster from "url:./4.jpg";

import caged from "url:./1512.jpg";
import cagedDetail from "url:./1514.jpg";
import smile from "url:./1528.jpg";
import smileDetail from "url:./1532.jpg";

import anHD from "url:./1897.jpg";
import underTheSun from "url:./2897.jpg";
import feelWarmth from "url:./1178.jpg";

import brain from "url:./1299.jpg";
import brainBurned from "url:./1501.jpg";

import enlightenment from "url:./1a.jpg";
import enlightenmentDetail from "url:./1b.jpg";

import caltrops from "url:./0755.jpg";


export default [
  { src: sunCage, alt: "sun cage" },
  { src: sunCageDetail, alt: "sun cage detail" },
  { src: childCage, alt: "child cage" },
  { src: cage, alt: "cage" },
  { src: iAwait, alt: "i await the clouds to break" },
  { src: bones, alt: "bones" },
  { src: solemn, alt: "solemn" },
  { src: redchamber, alt: "red chamber" },
  { src: home, alt: "home" },
  { src: misery, alt: "misery" },
  { src: keymaster, alt: "key master" },
  { src: caged, alt: "caged" },
  { src: cagedDetail, alt: "caged detail" },
  { src: smile, alt: "smile" },
  { src: smileDetail, alt: "smile detail" },
  { src: anHD, alt: "an hd240430 to call my own" },
  { src: underTheSun, alt: "under the sun" },
  { src: feelWarmth, alt: "i feel your warmth" },
  { src: brain, alt: "brain" },
  { src: brainBurned, alt: "brain burned" },
  { src: enlightenment, alt: "enlightenment" },
  { src: enlightenmentDetail, alt: "enlightenment detail" },
  { src: caltrops, alt: "caltrops" },
];
